import axiosInsAcademy from '@/api/axios-ugems-academy';

const userManagementMitraAPI = {
  // Get user mitra list
  getUserMitraList(params) {
    return axiosInsAcademy.get('/contractor-users', { params });
  },

  // Search user by NIK (from external source)
  searchUserByNik(params) {
    return axiosInsAcademy.get('/contractor-users/external', { params });
  },

  // Get user detail by NIK
  getUserDetailByNik(nik) {
    return axiosInsAcademy.get(`/contractor-users/${nik}`);
  },

  // Create user mitra
  createUserMitra(data) {
    return axiosInsAcademy.post('/contractor-users', data);
  },

  // Update user mitra (by NIK)
  updateUserMitra(nik, data) {
    return axiosInsAcademy.put(`/contractor-users/${nik}`, data);
  },

  // Delete user mitra (by NIK)
  deleteUserMitra(nik) {
    return axiosInsAcademy.delete(`/contractor-users/${nik}`);
  },

  // Get companies list
  getCompanies() {
    return axiosInsAcademy.get('/companies');
  }
};

export default userManagementMitraAPI;
